export default "__VITE_ASSET__0b6bee66__"